export default {
  v3OfficialTopUpCenterTitle: 'Resmi Yükleme Merkezi',
  v3OfficialTopUpCenterKeyword: 'Resmi Yükleme Merkezi',
  v3OfficialTopUpCenterDescription: 'Resmi Yükleme Merkezi',
  v3SafeAndFast: 'Güvenli, Risksiz ve Anında Hesaba Geçer',
  v3Shop: 'AVM',
  v3ShoppingCart: 'Alışveriş Sepeti',
  v3MembershipCenter: 'Ayrıcalık Merkezi (Ayrıcalıklı Üye Merkezi)',
  v3Login: 'Giriş Yap',
  v3Account: 'Hesap',
  v3EnterAccountName: 'Hesap Adı Girin',
  v3Password: 'Şifre',
  v3EnterPassword: 'Şifre Girin',
  v3ForgotPassword: 'Şifremi Unuttum',
  v3EnterUID: 'KK Girin',
  v3OTP: 'TKŞ',
  v3EnterOTP: 'TKŞ Girin',
  v3SelectTopUpCharacter: 'Yükleme karakterini seçin',
  v3SelectServer: 'Sunucu Seçin',
  v3Confirm: 'Onayla',
  v3CharacterNotFound:
    'Karakteri bulamazsanız, önce oyundaki karaktere giriş yapmayı deneyin, ardından yükleme sayfasına giriş yapın veya müşteri hizmetleriyle iletişime geçin.',
  v3Logout: 'Çıkış Yap',
  v3SwitchAccount: 'Hesap Değiştir',
  v3MyCoupons: 'Kuponlarım',
  v3BenefitsCenter: 'Ayrıcalıklı Üye Merkezi',
  v3TopUpBenefits: 'Yükleme Avantajları',
  v3MoreSettings: 'Diğer Ayarlar',
  v3RememberLoginStatus: 'Giriş durumumu hatırla',
  v3OrderQuery: 'Siparişleri Kontrol Et',
  v3ContactCustomerService: 'Müşteri Hizmetleri',
  v3LoginWithApp: 'Uygulama ile giriş yap',
  v3ChooseOtherLoginMethod: 'Alternatif bir giriş yöntemi seç',
  v3ConnectingToGameApp: 'Oyun uygulamasına bağlanıyor',
  v3EnsureGameInstalled:
    'Oyunun bu cihazda yüklü olduğundan emin olun. Oyun tepki vermiyorsa veya giriş yapamıyorsanız, oyunu uygulama mağazasından en son sürüme güncelleyin veya başka bir tarayıcıya geçin.',
  v3OpenGame: 'Oyunu Başlat',
  v3DownloadGame: 'Oyunu İndir',
  v3UpdateGameIfOpenFails:
    "Oyun başlatılamazsa, App Store'dan/Google Play'den en son sürüme güncelleyin.",
  v3ClickToDownloadLatestVersion:
    "Alternatif olarak, en son sürümü almak için 'oyunu indir' butonuna tıklayabilirsiniz.",
  v3LoggingIntoOfficialTopUpCenter:
    "[Resmi Yükleme Merkezi]'ne giriş yapıyorsunuz",
  v3CurrentAccount: 'Mevcut hesap: xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter: "Resmi Yükleme Merkezi'ne hoş geldiniz.",
  v3OfficialAuthorizedLogin:
    'Resmi olarak yetkilendirilmiş giriş. Güvenlik riski yok.',
  v3TermsOfService: 'Hizmet Şartları',
  v3PrivacyPolicy: 'Gizlilik Politikası',
  v3ThirdPartySocialAccountDescription:
    'Üçüncü Taraf Sosyal Medya Hesabı Hakkında',
  v3BindSocialAccountInGameFirst:
    "Önce oyundaki Kullanıcı Merkezi'nde sosyal medya hesabınızı bağlayın, ardından bağlı sosyal medya hesabınızla giriş yapın.",
  v3FirstTopUp15PercentOff:
    "İlk yüklemenizde %15'e varan indirimden yararlanın.",
  v3MoreTopUpRebates: 'Daha fazla yükleme indirimi ve ödül',
  v3LoginToViewOffers: 'İndirimleri görüntülemek için giriş yapın',
  v3TopUpEnvironmentChecking: 'Yükleme ortamı doğrulanıyor...',
  v3SafeToUse: 'Güvenli ve Emniyetli.',
  v3LimitedTimeBenefits: 'Özel Sınırlı Süreli Teklif',
  v3EventRules: 'Etkinlik Kuralları',
  v3MoreEvents: 'Diğer Etkinlikler',
  v3Claim: 'Talep Et',
  v3Completed: 'Tamamlandı',
  v3GoTo: 'Git',
  v3ViewDetails: 'Detayları Göster',
  v3RecommendedProducts: 'Önerilen Öğeler',
  v3SearchProductName: 'Öğe adına göre ara',
  v3AllCategories: 'Tümü',
  v3PopularSort: 'Çok Satan',
  v3PriceAscending: 'Fiyat ↑',
  v3PriceDescending: 'Fiyat ↓',
  v3DiamondBonus10Percent: 'Elmas +%10',
  v3YuanbaoBonus10Percent: 'Külçe +%10',
  v3ExtraBonus10Percent: 'Bonus: +%10',
  v3FirstTopUpDouble: '1. Yükleme İkiye Katlandı',
  v3FirstExtraBonus: '1. Sefer Bonusu',
  v3ProductDetails: 'Ürün Detayları',
  v3AddToCart: 'Sepete Ekle',
  v3AddedToCart: 'Sepete Eklendi',
  v3BuyNow: 'Şimdi Satın Al',
  v3NoItemsInCart: 'Sepetinizde henüz hiç ürün yok',
  v3SelectedItemsN: 'Seçilen öğeler: (${n})',
  v3RemoveFromCart: 'Sepetten çıkar?',
  v3Yes: 'Evet',
  v3No: 'Hayır',
  v3LimitOnePerPurchase: 'Bu öğeden yalnızca bir tane satın alınabilir.',
  v3ItemPrice: 'Öğe Fiyatı',
  v3Tax: 'Vergi',
  v3ExtraGift: 'Bonus',
  v3Total: 'Toplam',
  v3ProceedToPayment: 'Ödeme',
  v3SelectCoupon: 'Kupon Seç',
  v3UnavailableCoupons: 'Geçersiz Kuponlar',
  v3OneCouponPerOrder: 'Her sipariş için bir kupon',
  v3DiscountCoupon: 'İndirim Kuponu',
  v3ThresholdCoupon: 'İskonto Kuponu',
  v3MinSpendCoupon: "Toplam fiyat xx USD'yi aştığında kullanılabilir",
  v3MaxDiscountCoupon: "xxxx USD'ye varan indirim",
  v3LimitedChannel: 'Belirli kanallarla sınırlıdır',
  v3AllChannels: 'Tüm kanallar için mevcuttur',
  v3SpecificProducts: 'Yalnızca belirli ürünler',
  v3AllProducts: 'Her ürün için',
  v3NotYetTimeToUse: 'Henüz kullanılamaz',
  v3Expired: 'Süresi doldu',
  v3Used: 'Kullanıldı',
  v3ValidityPeriod: 'Geçerlilik:',
  v3ConfirmUse: 'Onayla',
  v3ChangeProduct: 'Öğeyi Değiştir',
  v3ConfirmPaymentOrder: 'Siparişi Onayla',
  v3StoredValueRole: 'Yükleme Karakteri',
  v3TotalNProducts: 'Toplam Öğe: ${n}',
  v3SelectPaymentMethod: 'Ödeme Yöntemi Seç',
  v3PayNow: 'Şimdi Öde',
  v3MorePaymentMethods: 'Diğer Ödeme Yöntemleri',
  v3NoAvailablePaymentMethodContactSupport:
    'Herhangi bir uygun ödeme yöntemi bulamıyor musunuz? Müşteri Hizmetleri ile iletişime geçin.',
  v3AvailableCoupons: 'Kullanılabilir Kuponlar',
  v3Extra10Percent: '+10%',
  v3LastSelection: 'Önceki Seçim',
  v3RecommendedUsage: 'Önerilen',
  v3PopularChoice: 'Popüler Tercih',
  v3PaymentSuccess: 'Ödeme Tamamlandı',
  v3PaymentFailure: 'Ödeme başarısız',
  v3TopUpFailureMessage:
    'Üzgünüz, yükleme işlemi başarısız oldu Siparişinizi tekrar oluşturmayı deneyin veya müşteri hizmetleri ile iletişime geçin.',
  v3Game: 'Oyun',
  v3UID: 'KK',
  v3OrderNumber: 'Sipariş Numarası',
  v3ProductContent: 'Öğe Detayları',
  v3ViewProductDetails: 'Öğe Detaylarını Göster',
  v3PaymentMethod: 'Ödeme Yöntemi',
  v3Complete: 'Tamamla',
  v3TopUpAgain: 'Tekrar Yükle',
  v3FriendlyReminderSaveOrderInfo:
    'Hatırlatma: Sipariş bilginizi daha hızlı işleme almak için ekran görüntüsünü kaydedin.',
  v3RechargeAgain: 'Tekrar Yükle',
  v3TransactionInProgress: 'İşlem gerçekleştiriliyor',
  v3CompletePaymentInChannel: 'Ödemeyi tamamlamak için ödeme kanalına geçin.',
  v3RestAssuredFastDeliveryAfterPayment:
    'Ödeme sonuçlandıktan sonra öğe gönderilecektir.',
  v3SaveOrderInfoForProgress:
    'İşlem ilerlemesini takip etmek için sipariş bilgilerinin ekran görüntüsünü alabilirsiniz.',
  v3PaymentCompleted: 'Ödeme tamamlandı',
  v3AddToHomeScreen: 'Ana Sayfaya ekle',
  v3AddShortcutForBonus: 'Ekstra ödüller almak için bir kısayol ekleyin',
  v3ShareSuccess: 'Paylaşıldı',
  v3ShareFailure: 'Paylaşılamadı',
  v3RewardClaimed: 'Ödül Alındı',
  v3RewardClaimFailed: 'Ödül Alınamadı',
  v3EventNotStarted: 'Etkinlik başlamadı',
  v3EventEnded: 'Etkinlik sona erdi',
  v3ClickSelectCoupon: 'Kuponu Seçmek İçin Tıklayın',
  v3CouponsRecommendedUsed: 'Önerilen Kupon Kullanıldı',
  v3CouponsSelected: 'Seçilen Kupon',
  v3NoCouponsAvaliable: 'Kullanılabilir Kupon Yok',
  v3SupplementStatus: 'Durum',
  v3SupplementNormal: 'Normal',
  v3SupplementBanned: 'Yasaklı',
  v3SupplementPendingPayment: 'Ödeme Bekleniyor',
  v3SupplementSwitchCharacter: 'Karakter Değiştir',
  v3SupplementAccountInfoInvalid: 'Hesap Bilgileri Geçersiz',
  v3SupplementContactGSForTopUpLink:
    'Lütfen GS ile iletişime geçerek bakiye yükleme bağlantısını alın',
  v3SupplementTopUpCompleted: 'Bakiye Yükleme Tamamlandı:',
  v3SupplementTotalRefundOrders: 'Toplam {} iade siparişi',
  v3SupplementPendingSupplementAmount: 'Bekleyen Ödeme Tutarı:',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    'Hesap/Karakter normal, ödeme gerekmez',
  v3SupplementEnjoyYourGame: 'İyi oyunlar!',
  v3SupplementOrderInformation: 'Sipariş Bilgileri',
  v3SupplementPendingPaymentAmount: 'Ödenecek Tutar:',
  v3LookUpCouponRule: 'Kupon Dağıtım Kurallarını Kontrol Edin',
  v3SwitchOldVersion: 'Eski Ödeme Platformuna Geç',
  v3FirstTopUpGiveaway: '1. Yükleme Bonusu',
  v3SecureConnection: 'Güvenli bağlantı kuruluyor',
  v3RequestTimeOut:
    'Yükleme zaman aşımına uğradı, lütfen daha sonra tekrar deneyin.',
  v3ConfirmLeave: 'Çıkış yap?',
  v3NoSubmitOrder: `Sepetiniz henüz onaylanmadı, çıkarsanız istediğiniz ürünleri kaçırabilirsiniz.`,
  v3ContinueSubmit: 'Devam et',
  v3LeaveSubmit: 'Ayrıl',
  v3RecentBug: 'Son satın alımlar',
  v3ScanCodeLogin: 'Scan Code Login',
  v3BindRole: 'Bind Role',
  v3ScanLoading: 'loading...',
  v3ScanExpired: 'QR code expired',
  v3ScanRefreshClick: 'Click to refresh',
  v3ScanRefreshTip: 'Please refresh and scan again',
  v3ScanRefresh: 'Refresh',
  v3ScanSucc: 'Scanned successfully',
  v3ScanAuth: 'Please confirm on your phone',
  v3ScanAuthSuccess: 'Authorization successful',
  v3ScanAuthSuccessTip: 'Logging in...',
  v3ScanUnauthorized: 'Authorization failed',
  v3ScanRefreshTip2: 'Log in to the game app to scan',
  v3ScanGuide: 'Scan Guide',
  v3ScanLoginError: 'Login error, please refresh and retry',
  v3ThirdPartyLogin: 'Third-party Login',
  v3NoMyLoginMethod: "Don't have my login method?",
  v3AccountPasswordLogin: 'Please enter account to bind game character',
  v3PwaTapShareOrMenuIcon: 'Tarayıcı araç çubuğundaki Paylaş veya Menü simgesine tıklayın',
  v3PwaFindAndTapAddToHomeScreen: 'Seçeneklerde "Ana Ekrana Ekle"yi bulun ve tıklayın',
  v3LaunchFromDesktopAndRewardToMailbox: 'Please launch from the desktop\nSelect a character and the reward will be sent to your mailbox',
  v3ClaimSuccessCheckMailbox: 'Başarıyla Alındı\nLütfen oyun içi posta kutunuzu kontrol edin',
  v3ProductLimitOnceBadge: 'TEK SEFERLİK',
  v3ProductWeeklyOnlyBadge: 'HAFTALIK',
  v3ProductMonthlyOnlyBadge: 'AYLIK',
  v3ProductDiscountBadge: '**% İNDİRİM',
};
